import { ApiErrorDto } from '../../autogen/bff-api'

export const isApiErrorDto = (e: unknown): e is ApiErrorDto => {
    if (e === null || e === undefined) {
        return false
    }
    return (e as ApiErrorDto).errorCode !== undefined
}
